import { useState } from 'react'
import { api } from '../api/client'

interface Props {
  onSaved: () => void
}

export function Settings({ onSaved }: Props) {
  const [base, setBase] = useState(api.getApiBase())
  const [token, setToken] = useState(api.getToken())
  const [showToken, setShowToken] = useState(false)

  function save() {
    api.setApiBase(base.trim())
    api.setToken(token.trim())
    onSaved()
  }

  function clear() {
    if (!confirm('确认清除所有配置？')) return
    localStorage.removeItem('fb_api_base')
    localStorage.removeItem('fb_api_token')
    onSaved()
  }

  return (
    <div className="settings">
      <h2>设置</h2>
      <p className="hint">
        浏览器内核跑在你本地机器上，前端只承载于 Cloudflare Pages。
        请配置你的 <strong>Cloudflare Tunnel URL</strong>（指向本地 Rust 后端）。
      </p>

      <label>
        后端 API 地址
        <input
          value={base}
          onChange={(e) => setBase(e.target.value)}
          placeholder="https://fb-tunnel.example.com"
        />
      </label>

      <label>
        API Token（后端鉴权用）
        <div className="token-row">
          <input
            type={showToken ? 'text' : 'password'}
            value={token}
            onChange={(e) => setToken(e.target.value)}
            placeholder="从 backend/.token 文件读取"
          />
          <button type="button" onClick={() => setShowToken(!showToken)}>
            {showToken ? '隐藏' : '显示'}
          </button>
        </div>
      </label>

      <div className="settings-actions">
        <button onClick={save}>保存</button>
        <button className="danger" onClick={clear}>清除</button>
      </div>

      <details className="help">
        <summary>如何获取这些值？</summary>
        <ol>
          <li>本地启动 Rust 后端（<code>cd backend && cargo run</code>）</li>
          <li>
            第一次启动时，后端会在 <code>backend/.token</code> 里生成一个 API token，控制台也会打印
          </li>
          <li>
            启动 Cloudflare Tunnel（<code>cloudflared tunnel run</code>），会得到一个 <code>https://*.trycloudflare.com</code> 的临时 URL，
            或者用你自己的子域名
          </li>
          <li>把 Tunnel URL 填到上面，token 填到下面</li>
        </ol>
      </details>
    </div>
  )
}